import TrustedHtml from '@components/common/TrustedHtml/TrustedHtml'
import ArrowRightIcon from '@components/icons/ArrowRightIcon/ArrowRightIcon'
import React, { FC, useState } from 'react'
import { FaqSubSection } from '../FaqModule'

import styles from './FaqAccordion.module.scss'

type FaqAccordionProps = {
  section: FaqSubSection
}

const FaqAccordion: FC<FaqAccordionProps> = ({ section }) => {
  const [expanded, setExpanded] = useState(false)

  return (
    <div
      className={`${styles.container} ${expanded && styles.expanded}`}
      key={section.title}
    >
      <div onClick={() => setExpanded(!expanded)} className={`${styles.title}`}>
        <ArrowRightIcon color="black" strokeWidth={3} />{' '}
        <p className="bodytext">{section.title}</p>
      </div>
      <TrustedHtml className={`${styles.body}`} html={section.body} />
    </div>
  )
}

export default FaqAccordion
